module.exports = __webpack_public_path__ + "sass-icon.svg?d5b4acbee1e78b66cc776fc24664d126";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/sass-icon.svg
// module id = 49
// module chunks = 0